module.exports = __webpack_public_path__ + "static/media/img_zendy05.fb06d28e.jpeg";